import { Component } from '@angular/core'
import { GuideRoutingService } from '../service/guide-routing.service'

@Component({
  selector: 'flowaccount-guide-footer',
  templateUrl: './guide-footer.component.html',
  styleUrls: ['./guide-footer.component.scss'],
})
export class GuideFooterComponent {
  prev$ = this.guideRoutingService.prev$
  next$ = this.guideRoutingService.next$

  constructor(private guideRoutingService: GuideRoutingService) {}

  clickOnTop() {
    if (window['app-component-state']) {
      window['app-component-state'].scrollPosition = [0, 0]
    }
  }
}
